import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ResolutionService {
  private selectedResolutionSubject: BehaviorSubject<number> = new BehaviorSubject<number>(window.innerWidth);
  public selectedResolution$: Observable<number> = this.selectedResolutionSubject.asObservable();

  public setResolution(width: number): void {
    if (!width || isNaN(width)) { return; }
    this.selectedResolutionSubject.next(width);
  }
}



